<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="editarQtdeSessoesPacoteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="atp">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Quantidade Total de Sessões</h5>
                            <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ atp.procedimento.search }} 
                        </div>

                        <az-input 
                            label="Quantidade"
                            type="number" 
                            required
                            :validate="validate"
                            v-model="atp.atendimento_pacote.in_quantidade_items" />

                        <pre v-if="false">{{ atp }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            atp: null, 
            validate: false, 
        }
    },

    components: { 
        AzSubmit,
        AzInput, 
    },

    methods: { 
        fechar_modal () { 
            $('#editarQtdeSessoesPacoteModal').modal('hide');
        },

        abrir(atp) { 
            this.atp = _.cloneDeep(atp);

            $('#editarQtdeSessoesPacoteModal').modal('show');
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'set_qtde_pacote_cobranca_total',
                dados: { 
                    id_atendimento_procedimento: this.atp.id_atendimento_procedimento,
                    qtde: this.atp.atendimento_pacote.in_quantidade_items,
                },
                modal: 'editarQtdeSessoesPacoteModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>
